import { action, computed, makeObservable, observable } from 'mobx'

export class StepperFormViewStore {
  activeStep = 0
  totalSteps = 0

  constructor() {
    makeObservable(this, {
      activeStep: observable,
      totalSteps: observable,

      isFirstStep: computed,
      isLastStep: computed,

      next: action,
      back: action,
      goTo: action,
      reset: action,
      setTotalSteps: action,
    })
  }

  get isFirstStep() {
    return this.activeStep === 0
  }

  get isLastStep() {
    return this.activeStep === this.totalSteps - 1
  }

  next() {
    if (!this.isLastStep) this.activeStep++
  }

  back() {
    if (!this.isFirstStep) this.activeStep--
  }

  goTo(step: number) {
    if (step >= 0 && step < this.totalSteps) {
      this.activeStep = step
    }
  }

  reset() {
    this.activeStep = 0
  }

  setTotalSteps(steps: number) {
    this.totalSteps = steps
  }
}
